import $ from 'jquery';

export default class Sidebar {
  constructor({ el }) {
    this.$el = $(el);
    $('.has-children > a', this.$el).on('click', this.toggleDropdown);
  }

  toggleDropdown(e) {
    if (document.documentElement.clientWidth < 721) {
      e.preventDefault();
      $(e.target).parent().toggleClass('open');

      return false;
    }
  }
}
